<template>
  <div>
    <div class="ui two item menu" style="margin-top: 30px; margin-bottom: 15px;">
      <a 
        class="item" 
        :class="{ active: currentTab === tabs.first }"
        @click="currentTab = tabs.first"
      >
        Packages
      </a>
      <a 
        class="item" 
        :class="{ active: currentTab === tabs.second }"
        @click="currentTab = tabs.second"
      >
        Readings
      </a>
    </div>

    <packages 
      :medicalMachine="medicalMachine"
      :items="items"
      v-if="currentTab === tabs.first" 
    />

    <readings 
      :medicalMachine="medicalMachine"
      v-if="currentTab === tabs.second" 
    />
  </div>
</template>

<script>
export default {
  components: {
    packages: require('./details_components/Packages').default,
    readings: require('./details_components/Readings').default
  },
  props: {
    medicalMachine: { type: Object, required: true},
    items: { type: Array, required: true }
  },
  data() {
    const tabs = {
      first: 'packages',
      second: 'readings'
    }
    
    return {
      tabs: tabs,
      currentTab: tabs.first
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/medical_machines/medical_machine_components/MedicalMachineDetails.vue